/* eslint no-undef: 0 */

/** Return label. */

export const label = (variable) => ({})

/** Return force variable. */
export const force = (variable) => ({})

/** Return plugin variable. */
export const plugin = (name) => window.__plugin_sources__.find(plugin => plugin.componentName === name)

/**
 * Invoke remote action.
 */
export const remoteAction = function (/* arguments */) {
  Visualforce.remoting.Manager.invokeAction(...arguments)
}

/**
 * Return remote action name with prefix.
 */
export function remoteActions (variable) {
  return window.__remoteActions__[variable]
}

/** Go to page (id is string with part of apex address). */
export const navigateToForce = (id) => {
  ((typeof sforce === 'undefined') || (sforce == null))
    ? window.location = '/' + id
    : sforce.one.navigateToSObject(id.replace('/', ''))
}

/** Go to main salesforce page. */
export const navigateToLogin = () => {
  window.location = '/'
}

/** Excluded (from default visibility) columns in tables. */
export const EXCLUDED_COLUMNS = ['Id']

/** Date / Time related fields */
export const DATE_FIELDS = ['DATE', 'DATETIME', 'TIME']

/** Max count of counters in single row */
export const COLUMN_SIZE = 12

/** Default row height */
export const ROW_HEIGHT = 20

/** Fill nested records. */
export const fillNested = (el) => {
  if (!el) {
    return null
  }
  Object.keys(el).map(recordKey => { // find and replace nested records
    if (typeof el[recordKey] === 'object') {
      Object.keys(el[recordKey]).map(nestedRecordKey => {
        el[recordKey + '.' + nestedRecordKey] = el[recordKey][nestedRecordKey]
      })
    }
  })
}

/**
 * Get SLDS Grid column size style.<br/>
 * Maximum number is defined in COLUMN_SIZE constant
 * @param {number} small - Small size
 * @param {number} medium - Medium size
 * @param {number} large - Large size
 */
export const colWidthClassName = (small, medium, large) => {
  return `slds-size--${small}-of-${COLUMN_SIZE}
     slds-medium-size--${medium}-of-${COLUMN_SIZE}
     slds-large-size--${large}-of-${COLUMN_SIZE}`
}

export const STANDARD_ICON = 'standard:empty'

export const parseIcon = (icon) => {
  const category = icon ? icon.substring(0, icon.indexOf(':')).toLowerCase().trim() : null
  const name = icon ? icon.substring(icon.lastIndexOf(':') + 1).toLowerCase().trim() : null
  return { category, name }
}

export const DATE_FORMAT = 'YYYY-MM-DD'

export const base = {}

export const multi = {
  isMulti: true,
  hideSelectedOptions: true,
  isClearable: true
}

/**
 * Generates random ID
 * @type {string}
 */
const ID_CHARS = '1234567890'

export const WEEKDAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

export const HOURS = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]

const DEFAULT_SUGGESTIONS_INTERVAL = 15

export const getSuggestions = (suggestionsInterval) => {
  const oneHourMinutes = 60
  let suggestions = []
  const intervals = oneHourMinutes / (suggestionsInterval || DEFAULT_SUGGESTIONS_INTERVAL)

  Array(2).fill(undefined).forEach((_, index) => {
    HOURS.forEach(hour => {
      Array(intervals).fill(undefined).forEach((_, idx) => {
        suggestions = [...suggestions, `${hour}:${idx === 0 ? '00' : idx * (suggestionsInterval || DEFAULT_SUGGESTIONS_INTERVAL)} ${index > 0 ? 'PM' : 'AM'}`]
      })
    })
  })
  return suggestions
}

export const idGenerator = () => {
  let id = ''
  for (let i = 0; i < ID_CHARS.length; i++) {
    id += ID_CHARS.charAt(Math.floor(Math.random() * ID_CHARS.length))
  }
  return id
}

export const checkIfOnlyDigits = (value) => {
  return /^[0-9]*$/.test(value)
}

export const checkIfOnlyNumber = (value) => {
  return /^(\d*\.)?\d+$/.test(value)
}

export const isTodayCheck = (date) => {
  const today = new Date()
  return date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
}
